import { zql } from '../../schema.js';
/** Name lookups for event logs. Call them only inside `tx.location === 'server'`. */
export async function findDrugName(tx, id) {
    if (!id)
        return undefined;
    return (await tx.run(zql.drugCatalogItems.where('id', '=', id).one()))?.name;
}
export async function findTradeNameName(tx, id) {
    if (!id)
        return undefined;
    return (await tx.run(zql.tradeNames.where('id', '=', id).one()))?.name;
}
/** A medication profile's name and the name of the drug it belongs to. */
export async function findProfileNames(tx, profileId) {
    if (!profileId)
        return { profileName: undefined, itemName: undefined };
    const profile = await tx.run(zql.medicationProfiles.where('id', '=', profileId).related('drugCatalogItem').one());
    return { profileName: profile?.name ?? undefined, itemName: profile?.drugCatalogItem?.name };
}
/** Name of a row by id, from rows loaded once. */
export function nameOf(rows) {
    return (id) => rows.find(row => row.id === id)?.name;
}
//# sourceMappingURL=log-names.js.map